import classNames from 'classnames';
import { forwardRef } from 'react';
const itemContentsCss = "i7hjzql";
export const ItemContents = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(itemContentsCss, props.className)} />;
});

require("./item_contents.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./item_contents.js");